export default class SitePolicy {
    /**
     * Check if user can create a site
     * @param {Object} user
     * @return {Boolean}
     */
    create(user) {
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin' || 
               (user.permissions?.site?.global?.create ?? false);
    }

    /**
     * Check if user can edit a site
     * @param {Object} user
     * @param {Object} site
     * @return {Boolean}
     */
    edit(user, site) {
        // If site is not provided, check global create permission
        if (!site) {
            return user.role.name === 'admin' || 
                   user.role.name === 'client_admin' || 
                   (user.permissions?.site?.global?.create ?? false);
        }
        // Check update permission for specific site
        return user.role.name === 'admin' || 
               user.role.name === 'client_admin' || 
               (user.permissions?.site?.[site.id]?.update ?? false) ||
               (user.site_permissions?.[site.id]?.update ?? false);
    }

    /**
     * Check if user can delete a site
     * @param {Object} user
     * @param {Object} site
     * @return {Boolean}
     */
    delete(user, site) {
        if (!site) {
            return false; // Can't delete if no site is specified
        }
        
        // For client users, check specific delete permission
        if (user.role.name === 'client_user') {
            return (user.permissions?.site?.[site.id]?.delete ?? false) ||
                   (user.site_permissions?.[site.id]?.delete ?? false);
        }
        
        // Admins and client admins can delete
        return user.role.name === 'admin' || user.role.name === 'client_admin';
    }
}
